module.exports = __webpack_public_path__ + "img/sz-yz-banner.9808af80.png";